var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScSeychelles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 45V0H0V15L60 45Z",
    fill: "#D92223"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 45V0H19.9969L60 45Z",
    fill: "#FCD955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 45V0H40.0031L60 45Z",
    fill: "#003D88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 45L0 30V45H60Z",
    fill: "#007A39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScSeychelles);
export default __webpack_public_path__ + "static/media/sc Seychelles.23fbd4316048c8c2a8674eee43e04091.svg";
export { ForwardRef as ReactComponent };